import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface ProfileFieldListingCardProps {
  resources: Array<{ label: string; id: string; field_type: string }>;
}

export const ProfileFieldListingCard = ({
  resources,
}: ProfileFieldListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.profile_fields")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_profile_fields_found")}
    renderItem={profile_field => (
      <>
        <span className="font-bold">
          {t("help_widget.copilot.chat_card.profile_field.name")}:
        </span>{" "}
        {profile_field.label},{" "}
        <span className="font-bold">
          {t("help_widget.copilot.chat_card.profile_field.field_type")}:
        </span>{" "}
        {profile_field.field_type}
      </>
    )}
    getItemKey={profile_field => profile_field.id}
  />
);
